import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

// Extended type for JWT token payload including secondaryRole
export interface DecodedToken {
	aud: string;
	email: string;
	exp: number;
	iat: number;
	iss: string;
	role: string;
	sub: string;
	isCompany: boolean;
	secondaryRole?: string;
}

/**
 * Decodes the JWT token and returns the decoded payload
 * @returns The decoded token or null if token is invalid
 */
export const decodeToken = (): DecodedToken | null => {
	try {
		const accessToken = Cookies.get('accessToken');
		if (!accessToken) return null;
		
		return jwtDecode<DecodedToken>(accessToken);
	} catch (error) {
		console.error('Error decoding token:', error);
		return null;
	}
};

/**
 * Checks if the user has admin secondary role
 * @returns boolean indicating if the user has admin secondary role
 */
export const hasAdminSecondaryRole = (): boolean => {
	const decodedToken = decodeToken();
	return decodedToken?.secondaryRole === 'ADMIN';
}; 